import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Root (head-agency manager) only — Agencies & Margins. */
export const rootAgencyManagerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isRoot() ? true : router.createUrlTree(['/app/search']);
};
